import { Route, Routes, Navigate, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ProtectedRoute from "./ProtectedRoute";
import { authRoutes } from "./modules/auth/AuthRoutes";
import { useEffect, useState } from "react";

const AppRouter = () => {
  const navigate = useNavigate();
  const { loginStatus } = useSelector((state) => state?.auth);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 500);

  useEffect(() => {
   
    const handleResize = () => {
      console.log("handle resize")
      const mobileView = window.innerWidth < 500;
     // setIsMobile(mobileView);

      if (!mobileView) {
        navigate("auth/chatlist");
      } else {
        navigate("auth/chats");
      }
    };
    handleResize()
    // window.addEventListener("resize", handleResize);
    // return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Routes>
      {authRoutes.map((route, index) =>
        route.element ? (
          <Route
            key={index}
            path={route.path}
            element={
              route.isProtected ? (
                <ProtectedRoute isLoggedIn={loginStatus}>
                  {route.element}
                </ProtectedRoute>
              ) : (
                route.element
              )
            }
          />
        ) : null
      )}
      <Route
        path="/"
        element={
          <Navigate
            replace
            to={loginStatus ? "/auth/chatlist" : "/auth/login"}
          />
        }
      />
      <Route path="*" element={<Navigate replace to="/" />} />
    </Routes>
  );
};

export default AppRouter;
